import { Immutable } from "immer";
import React from "react";
import { t } from "ttag";

import { isoWebPageURL } from "../../models/nominals";
import { ICategoryInfo } from "../../models/tempur-love";
import { Image } from "../Image";
import { Link } from "../Link";
import { RichText } from "../RichText";
import { SocialIcons } from "../SocialIcons";

type IBlogTileProps = Immutable<{
    tileImage?: {
        block: {
            url: string;
            title?: string | null;
        };
    } | null;
    tileTitle: string;
    tileBody: string;
    url: string;
    categories: readonly ICategoryInfo[];
    loveRootUrl: string;
    twitterHandle: string;
    showCategoryImages?: boolean;
}>;

export const BlogTile = (props: IBlogTileProps): React.JSX.Element => {
    return (
        <>
            {props.tileImage && (
                <Image
                    src={props.tileImage.block.url}
                    alt={props.tileImage.block.title || ""}
                />
            )}
            <h3>{props.tileTitle}</h3>
            <div>
                <RichText
                    html={props.tileBody}
                    suppressHydrationWarning={true}
                />
            </div>
            <p>
                <Link
                    className="blog-post__link"
                    href={isoWebPageURL.wrap(props.url)}
                >
                    {t`Read More`}
                </Link>
            </p>
            <SocialIcons
                categories={props.categories}
                loveRootUrl={props.loveRootUrl}
                city={null}
                state={null}
                pageUrl={props.url}
                tileImageUrl={props.tileImage?.block.url ?? ""}
                twitterHandle={props.twitterHandle}
                showCategoryImages={props.showCategoryImages}
                showShare={false}
            />
        </>
    );
};
